import Service from '@/services/Service'

class CategoryService extends Service {
  constructor() {
    super('CATEGORY')
    this.resource = 'categories'
  }

  createRequestUrl(payload) {
    let requestUrl = `${this.resource}?`

    if (payload && payload.id)
      requestUrl += this.hasParameter(requestUrl)
        ? `&ID=${payload.id}`
        : `ID=${payload.id}`
    if (payload && payload.nome)
      requestUrl += this.hasParameter(requestUrl)
        ? `&NOME=${payload.nome}`
        : `NOME=${payload.nome}`
    if (payload && payload.idPai)
      requestUrl += this.hasParameter(requestUrl)
        ? `&PARENT_ID=${payload.idPai}`
        : `PARENT_ID=${payload.idPai}`
    if (payload && payload.todos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${payload.todos}`
        : `TODOS=${payload.todos}`
    if (payload && payload.idIntegracao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&IDINTEGRACAO=${payload.idIntegracao}`
        : `IDINTEGRACAO=${payload.idIntegracao}`
    if (payload && payload.integrado)
      requestUrl += this.hasParameter(requestUrl)
        ? `&INTEGRADO=${payload.integrado}`
        : `INTEGRADO=${payload.integrado}`
    if (payload && payload.page)
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${payload.page}`
        : `page=${payload.page}`

    return requestUrl
  }

  translateToFirebird(obj) {
    let objFirebird = {
      ID: obj.codigo,
      NOME: obj.nome,
      TIPO: obj.tipo,
    }

    return objFirebird
  }

  translateFromFirebird(obj) {
    let objeto = {
      codigo: obj.ID,
      nome: obj.NOME,
      tipo: obj.TIPO,
    }

    return objeto
  }

  async getCategory(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getCategories(payload = null) {
    let requestUrl = this.createRequestUrl(payload)
    return await this.getAPI(requestUrl)
  }
}

export default new CategoryService()
